import React from "react";
import Container from "../components/Container";
import HeaderBanner from "../components/HeaderBanner";
import useLocale from "../locales";
import { Helmet } from "react-helmet";
const Disclaimer = () => {
  const { textData } = useLocale();
  const disclaimer = textData?.disclaimer;
  return (
    <>
      <Helmet>
        <title>GrowLifeFund Disclaimer | Important Financial Notice</title>
        <meta
          name="description"
          content="Read the GrowLifeFund Disclaimer to understand financial notices, usage limits, and key responsibilities. Stay informed before using our free online tools."
        />

        {/* Canonical */}
        <link rel="canonical" href="https://growlifefund.com/disclaimer" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="GrowLifeFund Disclaimer | Important Financial Notice"
        />
        <meta
          property="og:description"
          content="Read the GrowLifeFund Disclaimer to understand financial notices, usage limits, and key responsibilities. Stay informed before using our free online tools."
        />
        <meta property="og:url" content="https://growlifefund.com/disclaimer" />
        <meta property="og:site_name" content="growlifefund" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en" />
        <meta
          property="og:image:alt"
          content="GrowLifeFund free financial calculator disclaimer"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>
      <Container>
        <div className="my-[24px] ">
          <HeaderBanner name={disclaimer?.title} backUrl="/" />
          {disclaimer?.paragraphs?.map((item, index) => {
            if (item.type === "html") {
              return (
                <div className="" key={index}>
                  <p
                    key={index}
                    className="text-gray-font sm:text-[16px] text-[14px] font-lato-regular-400"
                  >
                    {item?.text1}
                    <a
                      rel="noreferrer"
                      href={item?.href}
                      target="_blank"
                      className="underline text-[#0000FF]"
                    >
                      {item?.link}
                    </a>
                    <span
                      key={index}
                      className="text-gray-font sm:text-[16px] text-[14px] font-lato-regular-400 ml-[2px]"
                    >
                      {item?.text2}
                    </span>
                  </p>
                </div>
              );
            } else {
              return (
                <div key={index}>
                  <h2 className="text-gray-font sm:text-[17px] text-[16px] font-lato-medium-500 mt-[20px]">
                    {item?.sectionTitle}
                  </h2>
                  {item?.content?.map((text, subIndex) => (
                    <p
                      key={subIndex}
                      className="text-gray-font sm:text-[16px] text-[14px] font-lato-regular-400 mt-[20px]"
                    >
                      {text}
                    </p>
                  ))}
                </div>
              );
            }
          })}
        </div>
      </Container>
    </>
  );
};

export default Disclaimer;
